module.exports = __webpack_public_path__ + "static/media/partner-image-01.5cc33f43.svg";